// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames/bind';

import isProduction from 'app/common/lib/isProduction';

import styles from './Stikers.module.scss';;


const cx = cn.bind(styles);

type Props = {
  showNew?: boolean,
  showFree?: boolean,
  disabled?: boolean,
}

const Stikers = ({ showNew, showFree, disabled }: Props) => {
  const { t } = useTranslation('cafeteria');

  const stickerNewClassName = cx(styles.sticker, { disabled });
  const stickerFreeClassName = cx(styles.sticker, { disabled }, styles.free);

  return (
    <div className={styles.root}>
      {showNew
        && <div className={stickerNewClassName}>
          {t('stiker_new', 'новый')}
        </div>}
      {showFree
        && !isProduction()
        && <div className={stickerFreeClassName}>
          {t('stiker_free', 'беспл.')}
        </div>}
    </div>
  );
};

export default Stikers;
